export enum SessionEventType {
  SESSION_START_LOGIN = 'SESSION_START_LOGIN',
  SESSION_START_APP_INITIALISED = 'SESSION_START_APP_INITIALISED',
  SESSION_START_APP_ACTION = 'SESSION_START_APP_ACTION',
  SESSION_ACTIVE = 'SESSION_ACTIVE',
  SESSION_END_INACTIVITY = 'SESSION_END_INACTIVITY',
  SESSION_END_LOGOUT = 'SESSION_END_LOGOUT'
}
